import {
  ref,
  reactive,
  onBeforeMount,
  watch,
  getCurrentInstance,
} from "@vue/composition-api";
import router from "@/router";
import store from "@/store";
import inventoryPrivilegeFormModel from "@/models/inventory/inventory-privilege-form";
import useValidationModal from "@/@core/components/base-modal/hooks/useValidationModal";

export default function useManageStockCouponExternal(props) {
  const vm = getCurrentInstance().proxy;
  const QUANTITY_ADD = 1;
  const QUANTITY_WITHDRAW = 2;
  const {
    fetchPrivilegeEntryDetail,
    fetchPrivilegeEntryImportCpc,
    fetchPrivilegeEntryExportCpc,
  } = inventoryPrivilegeFormModel();
  const {
    openDefaultErrorModal,
    openErrorModal,
    openSuccessModal,
    openWarningModal,
  } = useValidationModal();

  const formReward = reactive({
    entryId: "",
    name: "",
    reference: "",
    privilegeType: "",
    codeType: "",
    image: "",
    note: "",
    status: false,
    isImportAvailable : true
  });

  const loading = reactive({
    form: false,
  });

  const formManageStock = reactive({
    stockMode: 1,
    removalStrategy: 1,
    modeQty: 1,
    importMode: 1,
    removalExport: 1,
  });

  const formFile = reactive({
    name: "",
    file: null,
  });

  const disabledForm = reactive({
    stockMode: false,
    modeQty: true,
  });

  const modeAddQuantity = ref([{ label: "Import", value: 1 }]);

  const modeImport = ref([
    { label: "No Duplicate", value: 1 },
    { label: "Duplicate", value: 2 },
  ]);

  const selected = ref(QUANTITY_ADD);
  const qtyTotal = ref(0);
  const quantityValue = reactive({
    add: 0,
    withdraw: 0,
  });

  const stockModeOptions = ref([
    { label: "None", value: 1 },
    { label: "Overselling", value: 2 },
    { label: "Restricted", value: 3 },
  ]);

  const removalOptions = ref([
    { label: "FIFO", value: 1 },
    { label: "FEFO", value: 2 },
    { label: "LIFO", value: 3 },
  ]);

  const updateAddQuantity = (number) => {
    quantityValue.add = number;
  };

  const updateWithdraw = (number) => {
    quantityValue.withdraw = number;
  };

  const onModalOpen = () => {};

  const onUpload = (file) => {
    formFile.name = file.name;
    formFile.file = file.file;
  };

  const downloadTemplate = () => {
    window.location.href = "https://devbcrminternal.blob.core.windows.net/privilege-contianer/Template/Code_Template_New.xlsx"
  }

  const fetchReward = () => {
    let reward = props.rewardDetail;
    fetchPrivilegeEntryDetail.payload.Inventory_Id =
      router.currentRoute.params.ref;
    fetchPrivilegeEntryDetail.payload.Privilege_Id = reward.privilege_id;
    store
      .dispatch("api/apiRequest", fetchPrivilegeEntryDetail)
      .then((response) => {
        if (response.status == "success") {
          let resp = response.data.resp;
          formReward.entryId = resp.entry_id;
          formReward.name = resp.privilege.name_en;
          formReward.reference = resp.privilege.alt_reference;
          formReward.image = resp.privilege.image_url;
          formReward.privilegeType = resp.privilege.type_desc;
          formReward.codeType = resp.privilege.cpc_type_desc;
          formReward.status = resp.privilege.status;
          formReward.isImportAvailable = resp.is_import_available;
          qtyTotal.value = resp.remaining_qty;
          formManageStock.stockMode = resp.stock_mode;
          formManageStock.removalStrategy = resp.fullfillment_mode;
          if (resp.stock_mode != 1) {
            disabledForm.stockMode = true;
          }
        }
      })
      .catch((error) => {
      })
      .finally(() => {});
  };

  const onSubmitPrivilegeToInventory = () => {
    if (selected.value == QUANTITY_ADD) {
      fetchImportExternalCode();
    } else {
      fetchExportExternalCode();
    }
  };

  const fetchImportExternalCode = () => {
    loading.form = true;
    let payload = {
      Entry_Id: formReward.entryId,
      Stock_Mode: formManageStock.stockMode,
      Fullfillment_Mode: formManageStock.removalStrategy,
      Minimun_Qty: 0,
      Req_IdentityId: 1,
      Type: "import",
      Note: formReward.note || "-",
      Duplicate_Mode: formManageStock.importMode,
      Import_File: formFile.file,
    };
    fetchPrivilegeEntryImportCpc.payload = payload;
    store
      .dispatch("api/apiFormRequest", fetchPrivilegeEntryImportCpc)
      .then((response) => {
        openSuccessModal(
          "ทำรายการสำเร็จ !",
          null,
          "ตกลง",
          () => vm.$emit("onAddPrivilege"),
          () => vm.$emit("onAddPrivilege")
        );
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.form = false;
      });
  };

  const fetchExportExternalCode = () => {
    loading.form = true;
    let payload = {
      Entry_Id: formReward.entryId,
      Stock_Mode: formManageStock.stockMode,
      Fullfillment_Mode: formManageStock.removalStrategy,
      Minimun_Qty: 0,
      Req_IdentityId: 1,
      Type: "export",
      Note: formReward.note || "-",
      Removal_Stategy: formManageStock.removalExport,
      Withdraw: quantityValue.withdraw,
    };
    fetchPrivilegeEntryExportCpc.payload = payload;
    store
      .dispatch("api/apiFormRequest", fetchPrivilegeEntryExportCpc)
      .then((response) => {
        openSuccessModal(
          "ทำรายการสำเร็จ !",
          null,
          "ตกลง",
          () => vm.$emit("onAddPrivilege"),
          () => vm.$emit("onAddPrivilege")
        );
      })
      .catch((error) => {
        openDefaultErrorModal(error);
      })
      .finally(() => {
        loading.form = false;
      });
  };

  const resolveStatusLabel = (status) => {
    switch (status) {
      case 1:
        return "Active";
      case 2:
        return "Inactive";
      default:
        return "Unknown";
    }
  };

  const resolveStatusClass = (status) => {
    switch (status) {
      case 1:
        return "active-icon";
      case 2:
        return "inActive-icon";
      default:
        return "Unknown";
    }
  };

  watch(selected, () => {
    quantityValue.add = 0;
    quantityValue.withdraw = 0;
  });

  onBeforeMount(() => {
    fetchReward();
  });

  return {
    loading,
    formFile,
    formReward,
    formManageStock,
    QUANTITY_ADD,
    QUANTITY_WITHDRAW,
    selected,
    quantityValue,
    stockModeOptions,
    removalOptions,
    qtyTotal,
    modeAddQuantity,
    modeImport,
    disabledForm,
    onModalOpen,
    updateAddQuantity,
    updateWithdraw,
    onSubmitPrivilegeToInventory,
    resolveStatusLabel,
    resolveStatusClass,
    onUpload,
    downloadTemplate
  };
}
